// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.44412 12.0002C7.44412 9.4842 9.48371 7.44461 11.9997 7.44461C14.5156 7.44461 16.5552 9.4842 16.5552 12.0002C16.5552 14.5161 14.5156 16.5557 11.9997 16.5557C9.48371 16.5557 7.44412 14.5161 7.44412 12.0002ZM11.9997 9.88905C10.8337 9.88905 9.88856 10.8342 9.88856 12.0002C9.88856 13.1661 10.8337 14.1113 11.9997 14.1113C13.1656 14.1113 14.1108 13.1661 14.1108 12.0002C14.1108 10.8342 13.1656 9.88905 11.9997 9.88905Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12.9997 5.52039V4.3335H10.9997V5.52039C8.17982 5.952 5.95151 8.18031 5.51991 11.0002H4.33301V13.0002H5.51991C5.95151 15.82 8.17982 18.0483 10.9997 18.4799V19.6668H12.9997V18.4799C15.8195 18.0483 18.0478 15.82 18.4794 13.0002H19.6663V11.0002H18.4794C18.0478 8.18031 15.8195 5.952 12.9997 5.52039Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-aiming-filled')
export default class MapAimingFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-aiming-filled',
    }
  }
}
